import { useSelector } from '../../reduxToolkit/typedRedux';
import QAControl from '../account/qa/qaControl';
import VyModal from '../common/VyModal';

interface QAControlModalProps {
  open: boolean;
  onClose: () => void;
}
const QAControlModal = ({ open, onClose }: QAControlModalProps) => {
  const page = useSelector((state) => state.common.pagedata);

  return (
    <VyModal open={open} onClose={onClose} style={{ width: '80cqw' }} maxWidth="1333px">
      {() => <QAControl selectedPage={page} />}
    </VyModal>
  );
};

export default QAControlModal;
